import { showStatus } from './AxiosReqs';

export const updateDelStatus = async function (orderId) {
  try {
    const res = await axios({
      method: 'PATCH',
      url: `/api/v1/orders/update-delivery/${orderId}`,
    });

    if (res.data.status === 'success') {
      showStatus('success', 'Order Updated');
      window.setTimeout(() => window.location.reload(), 1500);
    }
  } catch (error) {
    console.log(error);
    showStatus('fail', 'Failed to Update Order');
  }
};

export const updateTrackingDetails = async function (
  orderId,
  trackingId,
  trackingLink
) {
  try {
    const res = await axios({
      method: 'PATCH',
      url: `/api/v1/orders/update-tracking/${orderId}`,
      data: {
        trackingId,
        trackingLink,
      },
    });

    if (res.data.status === 'success') {
      showStatus('success', 'Order Updated');
      window.setTimeout(() => window.location.reload(), 1500);
    }
  } catch (error) {
    console.log(error);
    showStatus('fail', 'Failed to Update Order');
  }
};
